import { DateTime } from 'luxon'
import cn from 'classnames'

import { PromotionReadFreeEnum } from '@interfaces/PromotionTypeEnum'
import { useStoryReader } from '@hooks/book/useStoryReader'
import { promotionDate } from '@lib/promotion/utils'

export function ReadPromotion({
  isTopBanner,
  isDrawer,
}: {
  isTopBanner?: boolean
  isDrawer?: boolean
}) {
  const { bookReadPromotionDetail: data } = useStoryReader()

  function expirePromotion() {
    const now = DateTime.now().toUTC().valueOf()
    const end = DateTime.fromISO(data?.currentReadPromotion.endDate || '')
      .toUTC()
      .valueOf()

    return now > end
  }

  function promotionType() {
    const readPromotionType = data?.currentReadPromotion.readPromotionType

    if (readPromotionType === PromotionReadFreeEnum.READ_FREE_PER_DAY) {
      return `รับสิทธิ์อ่านฟรีวันละ ${data?.currentReadPromotion.readFreePerDay} ตอน`
    }
    if (readPromotionType === PromotionReadFreeEnum.READ_FREE_WITHIN_DAY) {
      return `รับสิทธิ์อ่านฟรีภายใน ${data?.currentReadPromotion.readFreeWithinDay} วัน`
    }
    if (readPromotionType === PromotionReadFreeEnum.READ_FREE_INTERVAL) {
      return isTopBanner ? '' : 'รับสิทธิ์อ่านฟรี'
    }

    return null
  }

  if (!data || expirePromotion()) return <></>

  return (
    <>
      {isTopBanner ? (
        <div
          className={cn('font-medium font-mitr', {
            'mt-[40px] mb-[30px]': !isDrawer,
            'my-6': isDrawer,
          })}
        >
          <div
            className={cn('grid items-center min-h-[50px]', {
              'grid-cols-[160px_1fr]': !isDrawer,
              'grid-rows-[40px_1fr]': isDrawer,
            })}
          >
            <div
              className={cn(
                'flex items-center justify-center h-full text-white border border-primary bg-gradient-to-r from-[#3f54d9] to-[#79beff]',
                {
                  'rounded-[8px_0px_0px_8px]': !isDrawer,
                  'rounded-t-lg': isDrawer,
                }
              )}
            >
              รับสิทธิ์อ่านฟรี
            </div>
            <div
              className={cn('flex h-full border border-primary px-[20px]', {
                'rounded-[0px_8px_8px_0px] border-l-0 tablet-mobile:flex-col tablet-mobile:gap-y-[9px] desktop:items-center':
                  !isDrawer,
                'rounded-b-lg flex-col py-2': isDrawer,
              })}
            >
              <div className='desktop:mr-[10px] dark:text-dark-10'>
                {promotionType()}
              </div>
              <div className='dark:text-dark-10 font-light text-[16px] tablet-mobile:text-[12px]'>
                {promotionDate(
                  data.currentReadPromotion.startDate,
                  data.currentReadPromotion.endDate,
                  'ตั้งแต่วันที่',
                  true
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={cn('mobile:px-[20px] font-medium font-mitr', {
            'mt-[40px] mb-[30px]': !isDrawer,
            'my-6': isDrawer,
          })}
        >
          <div
            className={cn(
              'flex mobile:flex-col mobile:gap-y-[9px] items-center justify-center min-h-[78px] bg-gradient-to-r from-[#3f54d9] to-[#79beff] text-white',
              {
                'rounded-lg': !isDrawer,
                'mobile:rounded-lg': isDrawer,
              }
            )}
          >
            <div
              className={cn('desktop-tablet:mr-[10px]', {
                'text-[24px] mobile:text-[20px]': !isDrawer,
                'text-[18px] mobile:text-[16px]': isDrawer,
              })}
            >
              {promotionType()}
            </div>
            <div
              className={cn('font-light', {
                'text-[24px] mobile:text-[12px]': !isDrawer,
                'text-[18px] mobile:text-[12px]': isDrawer,
              })}
            >
              {promotionDate(
                data.currentReadPromotion.startDate,
                data.currentReadPromotion.endDate,
                'ตั้งแต่วันที่',
                true
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
